/*
 * Personal Digital Spaces LLC ("COMPANY") CONFIDENTIAL
 * Unpublished Copyright (c) 2026 Personal Digital Spaces LLC, All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains the property of COMPANY. The intellectual and technical concepts contained
 * herein are proprietary to COMPANY and may be covered by U.S. and Foreign Patents, patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is strictly forbidden unless prior written permission is obtained
 * from COMPANY.  Access to the source code contained herein is hereby forbidden to anyone except current COMPANY employees, managers, contractors or partners who have executed
 * Confidentiality and Non-disclosure agreements explicitly covering such access.
 *
 * The copyright notice above does not evidence any actual or intended publication or disclosure  of  this source code, which includes
 * information that is confidential and/or proprietary, and is a trade secret, of  COMPANY.   ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC  PERFORMANCE,
 * OR PUBLIC DISPLAY OF OR THROUGH USE  OF THIS  SOURCE CODE  WITHOUT  THE EXPRESS WRITTEN CONSENT OF COMPANY IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE
 * LAWS AND INTERNATIONAL TREATIES.  THE RECEIPT OR POSSESSION OF  THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS
 * TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT  MAY DESCRIBE, IN WHOLE OR IN PART.
 */
import React from 'react'
import Styles from './styles.module.sass'
import { RiAlertFill } from 'react-icons/ri'
import AssetsWithErrorsTable from './components/AssetsWithErrorsTable'
import ValidationModal from '../ValidationModal'
import DefaultProcess from '@/components/process/DefaultProcess'
import DataAssetForm from '../DataAssetForm'
import { useSetValidationsTable } from './useSetValidationsTable'
import DeleteDataModal from '../DeleteDataModal'
import { getAssetsBatchDataErrorByBatch } from '@/services/asset-batches'
import { useFetchItemsWithParamsV2 } from '@/hooks/fetch/useFetchItemsWithParamsV2'
import { useParams } from 'react-router-dom'

const NeedValidationTable = ({
  className = '',
  reloadBatch
}) => {
  const { batchId } = useParams()
  const {
    itemsResponse,
    loading,
    onChangePage,
    page,
    totalPages,
    reloadItems
  } = useFetchItemsWithParamsV2({
    fetchService: getAssetsBatchDataErrorByBatch,
    fetchParams: { id: batchId }
  })
  const {
    currentData,
    currentIds,
    deleteModalIsOpen,
    handleCloseDeleteModal,
    handleCloseModal,
    handleOpenDeleteModal,
    handleOpenModal,
    modalIsOpen
  } = useSetValidationsTable({ reloadItems })

  const modalBody = <DefaultProcess
    startComponent={
      (props) => <DataAssetForm
        batchId={currentIds.batchId}
        data={currentData}
        dataId={currentIds.dataId}
        isEdit={false}
        onCancel={handleCloseModal}
        reloadBatch={reloadBatch}
        {...props}
      />
    }
  />
  const total = itemsResponse?.total || 0

  return (
    <>
      { deleteModalIsOpen &&
        <DeleteDataModal
          batchId={currentIds.batchId}
          dataId={currentIds.dataId}
          isDataError={true}
          onClose={handleCloseDeleteModal}
        />
      }
      { modalIsOpen &&
        <ValidationModal
          title="Fix Asset Data"
          isOpen={modalIsOpen}
          onClose={handleCloseModal}
        >
          { modalBody }
        </ValidationModal>
      }
      <section className={className}>
        <h2 className={`${Styles.fontColor} ${Styles.title}`} >
          <RiAlertFill size="25" />CSV Rows Need Validation ({ total })
        </h2>
        <AssetsWithErrorsTable
          loading={loading}
          onChangePage={onChangePage}
          onDelete={handleOpenDeleteModal}
          onEdit={handleOpenModal}
          page={page}
          totalPages={totalPages}
          assets={itemsResponse?.data || []}
        />
      </section>
    </>
  )
}

export default NeedValidationTable
